module.exports = __webpack_public_path__ + "img/background.b32542bb.jpg";